module.exports = {"371071004":"怡园街道","371071007":"田和街道","371071108":"初村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371071.json
// module id = 1563
// module chunks = 0